// removed by extract-text-webpack-plugin
module.exports = {"AutoSuggestList":"_29x-h"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/AutoSuggestBox/AutoSuggestList/AutoSuggestList.scss
// module id = 882
// module chunks = 0